import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Grid, Popup, Input, Segment, Dropdown, Checkbox, Message, Icon} from 'semantic-ui-react';
import DatePicker from "react-datepicker"
import moment from "moment";
import debounce from "lodash.debounce";

const regex = new RegExp('[A-Za-z0-9 _.,!$]*');

export class DateFilterSupplierInvoices extends React.Component {
    constructor(props) {
        super(props);
       
        this.state = {
            filter: this.props.filter || "",
            fromDate:  moment().subtract(12, "months").toDate(),
            toDate: moment().toDate(),
            showAllInvoices: false, // The checkbox's state
            filterValid: true,
            advancedFilters : this.props.advancedFilters,
            advancedFilterSelections: {
                

            }, // Initialize an empty object for selections
          
            minFromDate: moment().subtract(6, "years").startOf('year').toDate(),// initial fromDate
            minToDate: moment().subtract(6, "years").startOf('year').add(1, 'days').toDate() // initial fromDate plus one day
        };

        this.debouncedSubmit = debounce(this.props.onSubmitFilter, this.props.interval || 500);
    }

    componentDidMount()
    {
       
    }

    componentDidUpdate(prevProps)
    {

        if (prevProps.filterValue !== this.props.filterValue) {
            this.setState({
                filter: this.props.filterValue
            }, () => {
                // Optionally: Do something after state update
                this.raiseChange()
            });
        }

            if(this.props.initialDate !== prevProps.initialDate)
            {
                const initialFromDate = this.props.initialDate ? moment(this.props.initialDate, "YYYY-MM-DD").toDate() : moment().subtract(12, "months").toDate();
                const initialToDate = this.props.initialDate ? moment(this.props.initialDate, "YYYY-MM-DD").add(1, "month").subtract(1, "day").toDate() : moment().toDate();
             

                this.fromDateChanged(initialFromDate)
                this.toDateChanged(initialToDate)
            }
        

        if (this.props.supplyOverride && (this.props.supplyOverride !== prevProps.supplyOverride)) {

          
            this.setState({
                advancedFilterSelections: {
                    ...this.state.advancedFilterSelections,
                    'Utility': [this.props.supplyOverride.toLowerCase()]
                }
            });
        }

        if (this.props.supplierOverride && (this.props.supplierOverride !== prevProps.supplierOverride)) {//LGHERE

          
            this.setState({
                advancedFilterSelections: {
                    ...this.state.advancedFilterSelections,
                    'Supplier': [this.props.supplierOverride.toLowerCase()]
                }
            });
        }

        
  
      if(this.state.filter === "" && this.props.filter !== "" && this.state.loadedSave === false)
      {
       
        this.setState({
          filter : this.props.filter,
          filterValid : true,
          loadedSave : true,
          advancedFilters : this.props.advancedFilters
        })
  
        this.debouncedSubmit({ filter: this.props.filter });
      } else
  
      {
        if(!this.state.advancedFilters && this.props.advancedFilters)
        {
        this.setState({
          advancedFilters : this.props.advancedFilters
        })
      }
      }
    }

    handleCheckboxChange = () => {
        const showAllInvoices = !this.state.showAllInvoices; // Toggle the current state
        //const fromDate = showAllInvoices ? moment().subtract(10, "years").toDate() : moment().subtract(1, "years").toDate();
        const fromDate = showAllInvoices ?  moment().subtract(6, "years").startOf('year').toDate() : moment().subtract(1, "years").toDate();
        this.setState({
            showAllInvoices,
            fromDate
        }, this.raiseChange);
    }

    handleChangeDropDown = (_p, { name, value }) => {
        this.setState(prevState => ({
            advancedFilterSelections: {
                ...prevState.advancedFilterSelections,
                [name]: value, // Update the selection for this filter
            }
        }), () => {
            // Check if the value is an empty array
            if (value.length === 0) {
                if (name === 'Supplier') {
                    this.props.updateSupplierOverride(""); // Reset supplier override
                } else if (name === 'Utility') {
                    this.props.updateSupplyOverride(""); // Reset supply override
                }
            }
    
            // Call onAdvancedFilterChange
            this.props.onAdvancedFilterChange({ name, value });
        });
    };

    handleOnChange = (event, {name, value}) => {

      
            // Update the local state and potentially notify parent components
        this.setState({ filter: event.target.value },  this.raiseChange);
            // If you need to };

        if (value !== '' && !regex.test(value)) {
            this.setState({[name]: value, filterValid: false});
        } else {
            this.setState({[name]: value, filterValid: true}, this.raiseChange);
        }
    };

    fromDateChanged = (newDate) => {
        this.setState({ fromDate: newDate || null }, this.raiseChange); // Reset to null if cleared

       

        this.props.trimGraphDates(this.state.toDate,newDate)
    }

    toDateChanged = (newDate) => {
        this.setState({ toDate: newDate || null }, this.raiseChange); // Reset to null if cleared
        this.props.trimGraphDates(newDate , this.state.fromDate )

    }

    raiseChange = () => {
        this.debouncedSubmit({filter: this.state.filter, fromDate: this.state.fromDate, toDate: this.state.toDate});
    }

    render() {
        const disabledStyle = {
            pointerEvents: "none", // Prevents any interaction
            opacity: 0.5, // Grays out the field
            backgroundColor: "#f3f4f6", // Optional: additional gray background for disabled
        };
        
        const {filter} = this.state;
        let popupMessage = '';
        if (!this.state.filterValid) {
            popupMessage = 'Invalid character.';
        } else if (this.props.totalCount === 0) {
            popupMessage = 'No results found.';
        }

        const CustomInput = ({ value, onClick, disabled }) => (
            <Input 
                fluidvalue={value} 
                value={value} 
                onClick={onClick} 
                iconPosition='left'  
                icon="calendar"
                style={disabled ? disabledStyle : {}}
            />
        );
        

        return (
            <Grid padded stackable columns='equal'>
                <Grid.Row >
                    <Grid.Column width={8}>
                        <Popup
                            trigger={
                                <Fragment>
                                    <h4>Filter</h4>
                                    <Input
                                        fluid
                                        placeholder="Enter the filter."
                                        name="filter"
                                        value={filter}
                                        defaultValue={filter}
                                        error={!this.state.filterValid}
                                        onChange={this.handleOnChange}
                                        icon="search"
                                        disabled={this.props.disabled}
                                        ref={ref => ref && ref.focus()}
                                        onFocus={(e)=>e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}
                

                                    />
                                </Fragment>
                            }
                            content={popupMessage}
                            on="click"
                            open={!this.state.filterValid || this.props.totalCount === 0}
                            position="right center"
                        />
                    </Grid.Column>
                    <Grid.Column width={4}>
                    <h4>{this.props.fromDateLabel ? this.props.fromDateLabel : 'From Date'}</h4>
                    <DatePicker 
                        selected={this.state.fromDate} 
                        locale="en-GB" 
                        isClearable={!this.state.showAllInvoices} 
                        minDate={this.state.minFromDate}
                        dateFormat="dd/MM/yyyy" 
                        onChange={this.fromDateChanged} 
                        customInput={<CustomInput disabled={this.state.showAllInvoices} />} 
                        disabled={this.state.showAllInvoices}
/>
                    </Grid.Column>
                    <Grid.Column width={4}>
                    <h4>{this.props.toDateLabel ? this.props.toDateLabel : 'To Date'}</h4>

                    <DatePicker 
    selected={this.state.toDate} 
    locale="en-GB" 
    isClearable={!this.state.showAllInvoices} 
    minDate={this.state.minToDate}


    dateFormat="dd/MM/yyyy" 
    onChange={this.toDateChanged} 
    customInput={<CustomInput disabled={this.state.showAllInvoices} />} 
        disabled={this.state.showAllInvoices}
/>
                    </Grid.Column>
                   

                </Grid.Row>
                <Grid.Row>
    <Grid.Column width={16}>
        <Checkbox
            label="Show all invoices"
            checked={this.state.showAllInvoices}
            onChange={this.handleCheckboxChange}
        />
    </Grid.Column>
    </Grid.Row>


    {(this.state && this.state.advancedFilters && this.state.advancedFilters.length) > 0 &&
              

              
              <Grid.Row>
                <Grid.Column>
              <Segment.Group horizontal>
           
                    {this.state.advancedFilters.map((el, index) =>  {

                    let options = [...el.filterValues];
                    


                    return (
                      <Segment key={index}>
                        <h4>
                        {el.filterName === 'HHDataType'
                            ? 'AMR/HH'
                            : el.filterName.replace(/([A-Z])/g, ' $1').trim()
                        }
                        </h4>
                      <Dropdown
                      
                      key={this.state.advancedFilterSelections[el.filterName] ? 'selected' : 'not-selected'} // Force re-render

                      name={el.filterName} 
                      placeholder={el.filterName} 
                      multiple fluid selection 
                      options={options}
                      value={this.state.advancedFilterSelections[el.filterName] || []} // Use state-controlled value

                      onChange={this.handleChangeDropDown} />
                      
                      </Segment>
                    );
                     } )}
                </Segment.Group>
                </Grid.Column>
            </Grid.Row>

            }

    <Grid.Row>
    <Grid.Column width={16}>
        <br></br>
    <Message warning>
                                <Icon size='large' name='warning sign'/>
                                <b>Please note: </b>For optimal performance, our portal is designed to display supplier invoices within a 2-year date range. Queries beyond this range may take up to a few minutes to process. Please be aware of this if you choose to view all invoices or select an extended date range.
                            </Message>
                            </Grid.Column>
</Grid.Row>
              
            </Grid>
        );
    }
}

DateFilterSupplierInvoices.propTypes = {
    initialDate: PropTypes.string, 
    onSubmitFilter: PropTypes.func.isRequired,
    onAdvancedFilterChange : PropTypes.func,
    interval: PropTypes.number,
    filter: PropTypes.any,
    disabled: PropTypes.bool,
    totalCount: PropTypes.number.isRequired,
    supplyOverride : PropTypes.string,
    supplierOverride : PropTypes.string
};
